<template>
    <div class="min-w-0 flex-1 text-sm text-gray-700">
        <input type="hidden" :name="name" :value="selected && hasNumber ? 1 : 0" />
        <label class="flex items-start gap-2 leading-snug">
            <input type="checkbox" v-model="selected" :disabled="!hasNumber" class="mt-1 flex-none" />
            <span>I consent to receive {{ channel === 'sms' ? 'text messages' : 'WhatsApp messages' }} from my team leader about my transactions.</span>
        </label>
        <div class="ml-5 mt-2 text-xs text-gray-500 leading-relaxed">
            <a href="/communication-terms" target="_blank" rel="noopener noreferrer" class="text-blue-600 underline">Communication Terms</a>
            <span class="sr-only"> (opens in a new tab)</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        channel: { type: String, required: true },
        number: { default: null },
        value: { default: false },
    },
    data() { return { selected: Boolean(this.value) }; },
    computed: {
        name() { return `team_${this.channel}_consent`; },
        hasNumber() { return Boolean(String(this.number || '').trim()); },
    },
    watch: {
        value(value) { this.selected = Boolean(value); },
        number(value, oldValue) {
            // Formatting changes do not transfer consent to another number.
            const digits = number => {
                let result = String(number || '').replace(/\D/g, '');
                return result.length === 10 ? '1' + result : result;
            };
            if (digits(value) !== digits(oldValue)) this.selected = false;
        },
    },
};
</script>
